import React from 'react';
import "./LogoCover.css";
 
export const LogoCover = () =>{
  return(
    <div className="logocover"></div>
  );  
};
